<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="$l('dialog_title_skuReply')"
      :visible="visible"
      direction="rtl"
      :size="1100"
      @close="() => $refs.main.cancel()"
    >
      <div class="drawer-main">
        <Main
          ref="main"
          :disabled="disabled"
          @close="close"
          @reload="$emit('reload')"
          :amzReplenishmentDetailCode="amzReplenishmentDetailCode"
        />
      </div>
      <div class="drawer-footer">
        <el-button size="small" @click="$refs.main.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button
          v-if="!disabled"
          type="warning"
          size="small"
          @click="notReplenishVisible = true"
        >
          {{ $l('INDEX.btn_notReplenish') || '不补货' }}
        </el-button>
        <el-button
          v-if="!disabled"
          type="danger"
          size="small"
          @click="$refs.main.outStock()"
        >
          {{ $l('btn_outStock') || '缺货' }}
        </el-button>
        <el-button
          v-if="!disabled"
          type="success"
          size="small"
          @click="$refs.main.confirm()"
        >
          {{ $l('btn_confirmReplenishment') || '确认补货' }}
        </el-button>
      </div>
    </el-drawer>

    <ReplyNotReplenish
      :amzReplenishmentDetailCode="amzReplenishmentDetailCode"
      :visible.sync="notReplenishVisible"
      @close="close"
      @reload="$emit('reload')"
    />
  </div>
</template>

<script>
import Main from './main.vue'
import ReplyNotReplenish from '../reply-not-replenish'
export default {
  components: { Main, ReplyNotReplenish },
  props: {
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    amzReplenishmentDetailCode: { type: String, default: '' },
  },
  data() {
    return {
      notReplenishVisible: false,
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 20px 10px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
